import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

import MainLayout from './components/layouts/MainLayout';

function App() {
  return (
    <>
      <MainLayout />

      <SpeedInsights />

      <Analytics />
    </>
  );
}

export default App;
